export const SET_USERINFO = 'SET_USERINFO';
export const SET_USERROLEINFO = 'SET_USERROLEINFO';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ROUTERS = 'SET_ROUTERS';
export const SET_TABS = 'SET_TABS';
export const DEL_TABS = 'DEL_TABS';
export const DEL_TABSARR = 'DEL_TABSARR';
export const DEL_TABSOTHER = 'DEL_TABSOTHER';
export const UPDATE_TABSOTHER = 'UPDATE_TABSOTHER';
export const DEL_TABROUTER = 'DEL_TABROUTER';
export const SET_REPORT = 'SET_REPORT';
export const SET_CURENTPAGE = 'SET_CURENTPAGE';
export const SET_PAGECOUNT = 'SET_PAGECOUNT';
export const SET_INFORMATIONMANAGERDATA = 'SET_INFORMATIONMANAGERDATA';
export const SET_CODE = 'SET_CODE';
export const SET_REFRESHTIME = 'SET_REFRESHTIME';
export const SET_FILELIST = 'SET_FILELIST';
export const SET_ENTERFORM = 'SET_ENTERFORM';
export const SET_BASICINFOID = 'SET_BASICINFOID';
export const SET_BASICINFO = 'SET_BASICINFO';
export const SET_END = 'SET_END';
export const SET_TRENDAREALIST = 'SET_TRENDAREALIST';
export const SET_SOURCEAREALIST = 'SET_SOURCEAREALIST';
export const SET_ACCESSAREALIST = 'SET_ACCESSAREALIST';
export const SET_TRENDCODE = 'SET_TRENDCODE';
export const SET_SOURCECODE = 'SET_SOURCECODE';
export const SET_ACCESSCODE = 'SET_ACCESSCODE';
export const SET_TABS_ROUTER ='SET_TABS_ROUTER';